require("../polyfills/event.custom");

export function addEvent(elem, event, fn, capture) {
    if (!elem) {
        return;
    }
    if (elem.addEventListener) {
        elem.addEventListener(event, fn, capture);
    } else {
        elem.attachEvent("on" + event, function() {
            // set the this pointer same as addEventListener when fn is called
            return(fn.call(elem, window.event));
        });
    }
}

export function delegateEvents(event, selectorMap) {
    for (let i in selectorMap) {
        let closestMatch = event.target.closest(i);
        if (closestMatch) {
            selectorMap[i].call(closestMatch, event);
        }
    }
}

export function fire(elem, eventName, data) {
    const event = new CustomEvent(eventName, data || {});
    elem.dispatchEvent(event);
    return event;
}

/**
 * Example:
 *  event.addEvent(window, 'resize', event.debounce(someExpensiveProcess, 500));
 */
export function debounce(callback, wait) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { callback.apply(this, args); }, wait);
    };
}
